export const reviews = [
  {
    author: "Jérôme Pont",
    rating: 5,
    date: "a month ago",
    review: "Arrived unexpectedly! Fast, efficient and friendly! I recommend it"
  },
  {
    author: "Bryan James",
    rating: 5,
    date: "11 months ago",
    review: "The hairdresser is super friendly, easy to get to, right next to Saint Lazare train station. I highly recommend him! He's meticulous and pays attention to every detail."
  },
  {
    author: "Antonin Chabanne (TonioRoiDuTango)",
    rating: 5,
    date: "11 months ago",
    review: "Great hair salon, the manager is lovely, punctual, and very professional. I'm happy with my haircut, see you soon!"
  },
  {
    author: "Emi",
    rating: 5,
    date: "2 months ago",
    review: "Effective, very reasonably priced."
  },
  {
    author: "Théo Chara",
    rating: 5,
    date: "11 months ago",
    review: "Very satisfied with this hair salon. Very decent hairdresser and clean hairstyle. Really nothing to complain about."
  },
  {
    author: "Crio Zola",
    rating: 5,
    date: "a year ago",
    review: "Always on top! Very good value for money! I recommend!"
  },
  {
    author: "Alan Closier",
    rating: 5,
    date: "8 months ago",
    review: "Great hairdresser, very friendly and fast"
  },
  {
    author: "Grégoire FOUR",
    rating: 5,
    date: "11 months ago",
    review: "Very warm welcome, efficient and pleasant, I recommend it and I would come back!"
  },
  {
    author: "Olvier ZEGUERMAN",
    rating: 5,
    date: "11 months ago",
    review: "Very good hairdresser, very pleasant."
  },
  {
    author: "Lyes Triki",
    rating: 5,
    date: "11 months ago",
    review: "Great barber I recommend!"
  },
  {
    author: "Romain Monnier",
    rating: 5,
    date: "a year ago",
    review: "I've been coming for a year, never disappointed, it's always excellent."
  },
  {
    author: "Léo Cheffi",
    rating: 5,
    date: "10 months ago",
    review: "super adorable hairstyle, on point"
  },
  {
    author: "Ali Ben",
    rating: 5,
    date: "11 months ago",
    review: "Super pro 🙏thanks …"
  },
  {
    author: "Guevara De faria",
    rating: 5,
    date: "4 months ago",
    review: "Real hairdresser"
  }
];